import { useState, useEffect } from 'react';

export const useNavigationParse = (title) => {
    const parseTitle = (title) => {
        if (title.includes('|')) {
            const [firstPart, secondPart] = title.split('|').map(part => part.trim());
            if (secondPart.startsWith('ICON:')) {
                const iconValue = secondPart.split(':')[1];
                return { text: firstPart, icon: iconValue };
            }
            if (secondPart.startsWith('CLASS:')) {
                const classVal = secondPart.split(':')[1];
                return { text: firstPart, class: classVal };
            }
        }
        return { text: title };
    };

    return parseTitle(title);
};